/**
 * Canonical `dataCategory` values returned by the Tax Configuration Admin API.
 *
 * Must stay in sync with
 * backend-shared/Pay.Roadrunner.Models/TaxConfiguration/TaxConfigurationConstants.cs
 * (`TaxConfigurationDataCategories`). Both sides use lower snake_case; this module is the
 * single place the frontend declares those values so no other file re-declares the literals.
 */
export const TAX_CONFIGURATION_DATA_CATEGORIES = {
  TaxScaleCatalogue: 'tax_scale_catalogue',
  PaygBracket: 'payg_bracket',
  MedicareLevyAdjustment: 'medicare_levy_adjustment',
  Stsl: 'stsl',
  Sapto: 'sapto',
  WorkingHolidayMaker: 'working_holiday_maker',
  Termination: 'termination',
  DeathBenefitEtp: 'death_benefit_etp',
  DelayedTermination: 'delayed_termination',
  Schedule7UnusedLeave: 'schedule_7_unused_leave',
  Schedule11Etp: 'schedule_11_etp',
  AgeRule: 'age_rule',
  TaxOffsetReduction: 'tax_offset_reduction',
  ExtraPayPeriodAdjustment: 'extra_pay_period_adjustment',
  FrequencyConversion: 'frequency_conversion',
} as const;
